import styled from 'styled-components';

export const ContentWrapper = styled.div`
    margin: 0 auto;
    max-width: 458px;
`;
